export default {
  app: {
    name: 'مروراتو',
    panel: 'پنل مدیریت مروراتو',
    tagline: 'مرکز مدیریت تجربه یادگیری دانش‌آموزان',
  },
  common: {
    save: 'ذخیره تغییرات',
    cancel: 'انصراف',
    close: 'بستن',
    search: 'جست‌وجو',
    searchPlaceholder: 'عبارت موردنظر را جست‌وجو کنید…',
    loading: 'در حال دریافت اطلاعات…',
    empty: 'اطلاعاتی برای نمایش وجود ندارد.',
    retry: 'تلاش دوباره',
    refresh: 'به‌روزرسانی اطلاعات',
    create: 'ایجاد',
    edit: 'ویرایش',
    update: 'به‌روزرسانی',
    delete: 'حذف',
    confirm: 'تأیید',
    view: 'مشاهده',
    details: 'مشاهده جزئیات',
    back: 'بازگشت',
    next: 'صفحهٔ بعد',
    prev: 'صفحهٔ قبل',
    yes: 'بله',
    no: 'خیر',
    all: 'همه موارد',
    actions: 'اقدامات',
    status: 'وضعیت',
    none: '—',
    total: 'تعداد کل',
    page: 'صفحه',
    of: 'از',
    filters: 'فیلترها',
    clear: 'پاک‌کردن فیلترها',
    apply: 'اعمال فیلترها',
    optional: 'اختیاری',
    required: 'الزامی',
    copy: 'کپی',
    copied: 'کپی شد',
    saved: 'تغییرات با موفقیت ذخیره شد.',
    error: 'در انجام عملیات مشکلی پیش آمد.',
    notImplemented: 'این بخش هنوز آماده استفاده نیست.',
    toastSuccess: 'انجام شد',
    toastError: 'خطا',
  },
  /**
   * ── this block stopped being the panel's navigation copy on 2026-09-04 ──────────────────────────
   *
   * §14.5 N6 gave every page ONE name and put it where the page is defined. A destination's name is now
   * `router/index.js`'s `meta.title` (with an optional `meta.navLabel` shortening for the menu row), and
   * a CONTAINER's name — the groups and accordions — is `components/layout/navigation.js`.
   * `AppSidebar.vue` reads both and carries no literals of its own.
   *
   * Twenty-two of the keys below were the SECOND name that made an operator click «مرکز فرماندهی» and
   * land on a page headed «داشبورد مدیریتی», with a browser tab agreeing with neither. `systemSweep`'s
   * R13.nav counted all 22; there is nothing left for it to count.
   *
   * TWO keys here are still read — `nav.profile`, by `header/UserMenu.vue` and `ProfilePage.vue`. The
   * rest are unreferenced and are kept, unedited, only because `scripts/lint-i18n.mjs` is a hard parity
   * gate and `en.js` (which is not this pass's file) carries the same keys. **Do not edit a value here
   * expecting a menu to change — it will not.** Delete the dead keys from both locales in one pass, or
   * leave them alone.
   */
  nav: {
    overview: 'نمای کلی',
    dashboard: 'مرکز فرماندهی',
    commandCenter: 'مرکز اقدام',
    learners: 'دانش‌آموزان',
    questionBank: 'مدیریت بانک سؤال',
    questions: 'همه سؤال‌ها',
    reviewQueue: 'سؤال‌های منتظرِ بازبینی',
    generate: 'تولید سؤال با هوش مصنوعی',
    quality: 'گزارش کیفیت سؤال‌ها',
    misconceptions: 'برداشت‌های نادرست رایج',
    curriculum: 'ساختار محتوای آموزشی',
    concepts: 'مفاهیم درسی',
    relationships: 'پیش‌نیازها و ارتباط مفاهیم',
    examWindows: 'برنامه آزمون‌های آزمایشی',
    plm: 'پروفایل یادگیری دانش‌آموز',
    plmValidation: 'ارزیابی دقت مدل یادگیری',
    plmExperiments: 'آزمایش سیاست‌های پیشنهادی',
    content: 'محتوا و ارتباط با کاربران',
    messages: 'پست‌های فید دانش‌آموزان',
    faq: 'راهنما و پرسش‌های متداول',
    account: 'حساب مدیریتی',
    profile: 'پروفایل من',
    engagement: 'تعامل، جامعه و پیام‌رسانی',
    revenue: 'درآمد و اشتراک',
    subscriptionPlans: 'پلن‌های اشتراک',
    subscriptions: 'اشتراک‌های فعال',
    deletionQueue: 'صف حذف حساب',
    notifications: 'مدیریت اعلان‌ها',
    leagues: 'لیگ‌ها',
    competitions: 'مسابقات',
    accessControl: 'کنترل دسترسی',
    adminManagement: 'مدیریت ادمین‌ها',
    adminRoles: 'نقش‌ها و مجوزها',
    auditLog: 'گزارش تغییرات',
    systemSettings: 'تنظیمات سیستم',
    featureFlags: 'پرچم‌های قابلیت',
    revenueAnalytics: 'تحلیل درآمد',
    gamificationEconomy: 'اقتصاد گیمیفیکیشن',
    growthSection: 'رشد، تحلیل و آزمایش',
    experiments: 'مدیریت آزمایش‌ها',
    productAnalytics: 'تحلیل محصول',
    platformOps: 'عملیات پلتفرم',
    integrations: 'یکپارچه‌سازی‌ها',
    systemHealth: 'سلامت سامانه',
    queueMonitor: 'صف پردازش‌ها',
    outboxQueue: 'صف انتشار رویدادها',
    cronSchedule: 'پردازش‌های زمان‌بندی‌شده',
    misconceptionLibrary: 'کتابخانه برداشت‌های نادرست',
    questionCoverage: 'پوشش و عملیات گروهی',
    curriculumVersions: 'نسخه‌های برنامهٔ درسی',
    graphAudit: 'گراف و بررسیِ نگاشت',
    securityEvents: 'امنیت و نشست‌ها',
    learnerOps: 'عملیات گروهی و آمار',
    notificationDelivery: 'تحویل اعلان',
    commsLog: 'گزارش ارسال پیام‌ها',
    batchOperations: 'عملیات دسته‌ای',
    plmEvents: 'رویدادها و ناهنجاری',
    populationLearning: 'تحلیل یادگیری کل دانش‌آموزان',
    segments: 'گروه‌های دانش‌آموزان',
    examBlueprint: 'بلوپرینت آزمون و ظرفیت',
    actionApprovals: 'تأیید تغییرات حساس',
    compliance: 'انطباق و خروجی داده',
    deletionLifecycle: 'چرخهٔ حذف حساب',
    guardians: 'اطلاعات تماس اولیا',
    schoolConsole: 'مدارس و کلاس‌ها',
    schoolAnalytics: 'تحلیل مشارکت مدارس',
    schoolClasses: 'مدیریت کلاس‌ها',
    globalSearch: 'جست‌وجوی سراسری',
    alertInbox: 'صندوق هشدار',
    contentModeration: 'مدیریت محتوا',
    coupons: 'کدهای تخفیف',
    appConfig: 'نسخهٔ اپ و ریموت‌کانفیگ',
    forecastAudit: 'پیش‌بینی مسیر دانش‌آموز',
    streakHealth: 'سلامت استریک',
    coverageHeatmap: 'نقشه پوشش محتوا',
    questionCalibration: 'کالیبراسیون سؤال‌ها',
    subjectBalance: 'تمرکز تمرین روی درس‌ها',
    examCountdown: 'شمارش معکوس کنکور',
    retentionCohorts: 'ماندگاری کوهورت',
    atRiskLearners: 'هشدار اولیه ریزش',
    mockExamAnalytics: 'آزمون‌های آزمایشی',
    fsrsHealth: 'سلامت حافظه FSRS',
    examReadiness: 'آمادگی از نگاه مدل',
    weaknessMap: 'ضعف مباحث از نگاه مدل',
    cognitivePerformance: 'الگوی پاسخ‌گویی',
    learningGains: 'تغییر امتیاز مدل یادگیری',
    growthTrend: 'شروع تمرین و ثبت‌نام',
    campaignEffectiveness: 'اثربخشی کمپین‌ها',
    churnTimeline: 'روند ریزش دانش‌آموزان',
    contentGap: 'کمبودِ پوشش به تفکیکِ کتابِ درسی',
    aiGenerationQuality: 'تأیید و ردِ سؤال‌های مدل',
    difficultyDrift: 'فاصلهٔ سختیِ تخمینی با واقعیت',
    prerequisiteViolations: 'بررسی پیش‌نیازهای ضعیف',
    goalProgress: 'پیشرفت هدف‌گذاری',
    milestones: 'مایل‌استون‌های یادگیری',
    liveSessions: 'سشن‌های زنده',
    endpointLatency: 'تأخیر Endpoint',
    slowQueries: 'کوئری‌های کند',
  },
  auth: {
    signInTitle: 'ورود به پنل مدیریت مروراتو',
    signInSubtitle: 'برای دسترسی به ابزارهای مدیریتی، ایمیل و گذرواژه خود را وارد کنید.',
    email: 'ایمیل سازمانی',
    password: 'گذرواژه',
    show: 'نمایش گذرواژه',
    hide: 'پنهان‌کردن گذرواژه',
    submit: 'ورود به پنل',
    signingIn: 'در حال بررسی اطلاعات ورود…',
    invalid: 'ایمیل یا گذرواژه صحیح نیست. اطلاعات را بررسی و دوباره تلاش کنید.',
    welcome: 'مدیریت مروراتو، یک‌جا و شفاف',
    welcomeBody: 'وضعیت دانش‌آموزان، محتوای آموزشی، بانک سؤال و عملکرد مدل یادگیری را از این پنل مدیریت کنید.',
    logout: 'خروج از حساب',
    loggedOut: 'با موفقیت از حساب مدیریتی خارج شدید.',
  },
  dashboard: {
    title: 'مرکز فرماندهی',
    subtitle: 'خلاصه وضعیت کاربران، محتوا و سرویس‌های اصلی مروراتو',
    learners: 'دانش‌آموزان ثبت‌نام‌شده',
    admins: 'کاربران مدیریتی',
    activeExamWindows: 'مراحل آزمون فعال',
    faqCategories: 'دسته‌های راهنما',
    publishedMessages: 'پیام‌های منتشرشده',
    practiceSessions: 'جلسه‌های تمرین',
    competitionMatches: 'رقابت‌های برگزارشده',
    systemStatus: 'سلامت سرویس‌های اصلی',
    database: 'پایگاه داده',
    apiRuntime: 'بک‌اند و API',
    realtimeGateway: 'ارتباط زنده مسابقه',
    eventStream: 'پردازش رویدادها',
    generatedAt: 'آخرین به‌روزرسانی',
    statusOk: 'در دسترس',
    statusConfigured: 'راه‌اندازی‌شده',
    statusPlanned: 'در برنامه توسعه',
  },
  learners: {
    title: 'دانش‌آموزان',
    subtitle: 'جست‌وجوی دانش‌آموز و بررسی وضعیت تحصیلی و مسیر یادگیری او',
    searchPlaceholder: 'نام، ایمیل یا شماره موبایل دانش‌آموز…',
    field: 'رشته تحصیلی',
    grade: 'پایه تحصیلی',
    name: 'نام دانش‌آموز',
    phone: 'شماره موبایل',
    joinedAt: 'تاریخ عضویت',
    openModel: 'مشاهده پروفایل یادگیری',
    inspector: 'پروفایل یادگیری دانش‌آموز',
    practiceSessions: 'جلسه‌های تمرین',
    noProfile: 'نام ثبت نشده',
  },
  subscriptions: {
    title: 'اشتراک‌های فعال',
    subtitle: 'مشاهده، اعطا و ابطال اشتراک‌های ویژه دانش‌آموزان',
    searchPlaceholder: 'نام یا شمارهٔ دانش‌آموز',
    plan: 'طرح',
    status: 'وضعیت',
    source: 'منبع',
    expiresAt: 'انقضا',
    grantTitle: 'اعطای اشتراک ویژه',
    grantSubtitle: 'برای موارد پشتیبانی یا هدیه، بدون عبور از درگاه پرداخت اشتراک ویژه فعال کنید.',
    userId: 'شناسه دانش‌آموز (عدد)',
    planKey: 'کلید طرح',
    durationDays: 'تعداد روز (خالی = مدت طرح)',
    grant: 'اعطای اشتراک',
    revokeConfirm: 'از ابطال این اشتراک مطمئن هستید؟',
    revoke: 'ابطال',
    active: 'فعال',
    expired: 'منقضی',
    revoked: 'باطل‌شده',
  },
  deletionQueue: {
    title: 'صف حذف حساب',
    subtitle: 'درخواست‌های حذف حساب در دوره ۷ روزه انتظار؛ تا پیش از اجرای پردازش پاک‌سازی می‌توان آن‌ها را لغو کرد.',
    searchPlaceholder: 'نام، ایمیل یا شماره…',
    requestedAt: 'تاریخ درخواست',
    confirmedAfter: 'اجرا از',
    reason: 'دلیل',
    cancelConfirm: 'از لغو درخواست حذف این کاربر مطمئن هستید؟',
    cancel: 'لغو درخواست حذف',
    purgeImminent: 'پاک‌سازی قریب‌الوقوع',
    noRequests: 'هیچ درخواست حذف فعالی در صف وجود ندارد.',
  },
  plm: {
    dimensions: 'شاخص‌های مدل یادگیری',
    knowledge: 'میزان تسلط',
    memory: 'ماندگاری یادگیری',
    confidence: 'اطمینان به پاسخ',
    misconception: 'برداشت‌های نادرست',
    cognitive: 'مهارت‌های شناختی',
    behavior: 'رفتار و انگیزه',
    weakness: 'نقاط نیازمند تقویت',
    readiness: 'آمادگی برای آزمون',
    opportunities: 'فرصت‌های پیشنهادی یادگیری',
    recommendations: 'اقدام‌های پیشنهادی',
    gain: 'پیشرفت یادگیری',
    forecast: 'پیش‌بینی مسیر یادگیری',
    validationTitle: 'ارزیابی دقت مدل یادگیری',
    experimentsTitle: 'آزمایش سیاست‌های پیشنهاددهی',
  },
}
